import { generateApiPath } from "@routes/generatePath.ts";
import { assigned } from "@api/msp/assigned/path";
import { assignToDoctor } from "@api/msp/assignToDoctor/path";
import { appointments } from "@api/msp/appointments/path";
import { doctors } from "@api/msp/doctors/path";
import type { IExtractApiParams } from "@routes/types";
import { assignedDoctors } from "@api/msp/assignedDoctors/path";
import { deassign } from "@api/msp/deassign/path";
import { services } from "@api/msp/services/path";
import { files } from "@api/msp/files/path";
import { workingTimes } from "@api/msp/workingTimes/path";
import { status } from "@api/msp/status/path";

const pathBase = `/medical-service-provider/`;

const pathById = `${pathBase}:mspId/`;

type IPathByIdParams = IExtractApiParams<typeof pathById>;

export const msp = {
  getAll: () => generateApiPath(pathBase),
  post: () => generateApiPath(pathBase),
  get: (params: IPathByIdParams) => generateApiPath(pathById, params),
  put: (params: IPathByIdParams) => generateApiPath(pathById, params),
  assigned,
  assignToDoctor,
  appointments,
  doctors,
  assignedDoctors,
  deassign,
  services,
  files,
  workingTimes,
  status,
};
